interface Props {
  id: number
  url: string
  thumbnail: string
  handleClick: (id: number, url: string, thumbnail: string) => void
  isActive: boolean
}

const ImageSelectionItem = (props: Props) => {
  const {
    url, id, thumbnail, handleClick, isActive,
  } = props;

  return (
        <li className={isActive ? 'imageitem active' : 'imageitem'} onClick={() => handleClick(id, url, thumbnail)}>
            <div className="image-image">
              <img src={thumbnail} alt="" />
            </div>
        </li>
  );
};

export default ImageSelectionItem;
